// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import type { TRIP_TYPE } from '../../types/trips';
import { MAPBOX_TOKEN, MAPBOX_STYLES } from '../../settings';
import Bus from '../Bus/index';
import { startFetchSchoolTrips } from '../../actions/trips';
import * as selectors from '../../reducers/index';
import RouteDrawing from '../RouteDrawing/RouteDrawing';
import MapStatus from '../MapStatus';
import * as mapActions from '../../actions/map';
import { updateBus } from '../../actions/buses';
import styles from './map.css';
import type { POINT_TYPE } from '../../types/common';


type MapPropTypes = {
  trips: Array<TRIP_TYPE>,
  selectedRoute: number,
  onLoad: Function,
  zoom: number,
  position: { longitude: number, latitude: number },
  // animate: boolean,
  setMapPosition: Function,
  onStartDragging?: Function
};

type MapStateTypes = {
  isMapLoaded: boolean,
  map: mapboxgl.Map,
  sourceName: string,
  isDragging: boolean
};

class Map extends Component<MapPropTypes, MapStateTypes> {
  constructor(props) {
    super(props);
    this.state = {
      isMapLoaded: false,
      map: undefined,
      sourceName: '',
      isDragging: false,
    };
  }

  componentWillMount() {
    const { onLoad } = this.props;
    onLoad();
  }

  componentDidMount() {
    const {
      setMapPosition,
      zoom,
      position: { longitude, latitude },
      onStartDragging,
    } = this.props;
    mapboxgl.accessToken = MAPBOX_TOKEN;
    const sourceName = 'busesSource';

    const map = new mapboxgl.Map({
      container: 'rootMap',
      style: MAPBOX_STYLES,
      center: [longitude, latitude],
      zoom,
      attributionControl: false,
      fadeDuration: 0,
    });

    // Adds layers to map in order to render points
    map.on('load', () => {
      // Dat source
      map.addSource(sourceName, {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [],
        },
      });

      // Points layer
      map.addLayer({
        id: 'points',
        source: sourceName,
        type: 'circle',
        paint: {
          'circle-radius': 25,
          'circle-opacity': 0,
        },
      });

      // Popover layer
      map.addLayer({
        id: 'popovers',
        source: sourceName,
        type: 'symbol',
      });

      map.on('mousedown', (a) => {
        /* const point = a.lngLat; */
        // this.props.updateBus(3, { latitude: point.lat, longitude: point.lng });
        this.setState({ isDragging: true });
        return onStartDragging && onStartDragging();
      });

      map.on('mouseup', () => {
        const { isDragging } = this.state;
        if (isDragging) {
          setMapPosition(
            map.getZoom(),
            map.getCenter().lng,
            map.getCenter().lat,
            false,
          );

          this._flyTo(
            map.getCenter().lng,
            map.getCenter().lat,
            map.getZoom(),
          );
          this.setState({ isDragging: false });
        }
      });

      const { position } = this.props;
      setTimeout(() => {
        this._flyTo(position.longitude, position.latitude, zoom);
      }, 100);

      // Set the map ready to render!
      this.setState({
        isMapLoaded: true,
        map,
        sourceName,
      });
    });
  }

  componentWillReceiveProps(nextProps: MapPropTypes) {
    const { zoom, position: { latitude, longitude } } = this.props;
    const nextLatitude = nextProps.position.latitude;
    const nextLongitude = nextProps.position.longitude;
    const nextZoom = nextProps.zoom;

    // If there is any change
    if (nextZoom !== zoom || nextLatitude !== latitude || nextLongitude !== longitude) {
      this._flyTo(
        nextLongitude,
        nextLatitude,
        nextZoom,
      );
    }
  }

  _flyTo(
    longitude: number,
    latitude: number,
    zoom: number,
  ) {
    const { map } = this.state;

    if (typeof map !== 'undefined') {
      map.flyTo({
        center: [longitude, latitude],
        zoom,
        speed: 1.5,
        curve: 1,
        easing: t => t,
      });
    }
  }


  render() {
    const { isMapLoaded = false, map, sourceName } = this.state;
    const { trips=[], selectedRoute } = this.props;
    return (
      <div className={styles.rootMap} id="rootMap">
        {
          isMapLoaded && trips.length
            ? trips.map(
              (trip, i) => (
                <Bus
                  key={trip.bus}
                  tripId={trip.id}
                  id={trip.bus}
                  sourceName={sourceName}
                  map={map}
                />
              ),
            ) : null
        }
        {
          isMapLoaded && selectedRoute && (
            <RouteDrawing
              map={map}
              sourceName={sourceName}
              selectedRoute={selectedRoute}
            />
          )
        }
        <MapStatus />
      </div>
    );
  }
}


export default connect(
  state => ({
    trips: selectors.getVisibleTrips(state),
    profile: selectors.getProfileOfType(state, 'admin'),
    selectedRoute: selectors.getCurrentRoute(state),
    position: selectors.getMapPosition(state),
    zoom: selectors.getMapZoom(state),
    animate: selectors.getMapAnimate(state),
  }),
  dispatch => ({
    onLoad(schoolId) {
      dispatch(startFetchSchoolTrips(schoolId));
    },
    updateBus: (id: number, location: POINT_TYPE) => dispatch(updateBus(id, location)),
    setMapPosition(zoom: number, longitude: number, latitude: number, animate: boolean) {
      dispatch(mapActions.setMapPosition(
        zoom,
        longitude,
        latitude,
        animate,
        { longitude: -0.5, latitude: 0.50 },
      ));
    },
    onStartDragging() {
      dispatch(mapActions.setMapDirty());
    },
  }),
  ({ profile, ...stateProps }, { onLoad, ...dispatchProps }, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onLoad: () => (profile ? onLoad(profile.school) : undefined),
  }
  ),
)(Map);



// WEBPACK FOOTER //
// ./src/scripts/components/Map/index.jsx